import EmailFormSection from "./emailForm/EmailFormSection";
import MobilePhoneFormSection from "./mobilePhoneForm/MobilePhoneFormSection";
import SelfReadingFormSection from './selfReadingForm/SelfReadingFormSection';
import TransitionToEmailComFormSection from './transitionToEmailComForm/TransitionToEmailComFormSection';
import NameFormSection from './nameForm/NameFormSection';
import ComplaintFormSection from './complaintForm/ComplaintFormSection';
import AddressFormSection from './addressForm/AddressFormSection';
import CapacityRateCircuitBreakerMainSection from './capacityRateCircuitBreakerForm/CapacityRateCircuitBreakerMainSection';
import PaymentMethodFormSection from './paymentMethodForm/PaymentMethodFormSection';
import AdvanceFormSection from './advanceForm/AdvanceFormSection';
import BaseRequirementFormProps from 'features/requirements/models/BaseRequirementFormProps';
import ReservedCapacityGasFormSection from "./reservedCapacityGas/ReservedCapacityGasFormSection";
import PhoneFormSection from "./phoneForm/PhoneFormSection";
import ReservedCapacityElectricityMonthlyFormSection from "./reservedCapacityElectricity/ReservedCapacityElectricityMonthlyFormSection";
import ReservedCapacityElectricityYearlyFormSection from "./reservedCapacityElectricity/ReservedCapacityElectricityYearlyFormSection";
import ETS2AffidavitFormSection from "./ets2AffidavitForm/ETS2AffidavitFormSection";

interface ComponentMap {
  [key: string]: (props?: BaseRequirementFormProps) => JSX.Element;
}

export const RequirementTypesMap: ComponentMap  = {
  "ZMENA_EMAILU": EmailFormSection,
  "ZMENA_MOBIL_TELEFONU": MobilePhoneFormSection,
  "ZADANISAMOODECTU": SelfReadingFormSection,
  "PRECHODEMAILKOMUNIKACE": TransitionToEmailComFormSection,
  "ZMENAJMENAAPRIJMENI": NameFormSection,
  "REKLAMACE": ComplaintFormSection,
  "ZMENATRVALEADRESY_SIDLASPOLECNOSTI": AddressFormSection,
  "ZMENADISTRIBUCNISAZBY_JISTICE_REZERVOVANEHOPRIKONU": CapacityRateCircuitBreakerMainSection,
  "ZMENAZPUSOBUPLATBY": PaymentMethodFormSection,
  "ZMENAZALOH": AdvanceFormSection,
  "ZMENAKAPACITYPLYN": ReservedCapacityGasFormSection,
  "ZMENATELEFONU": PhoneFormSection,
  "ZMENAKAPACITYELEKTRINAMESICNI": ReservedCapacityElectricityMonthlyFormSection,
  "ZMENAKAPACITYELEKTRINAROCNI": ReservedCapacityElectricityYearlyFormSection,
  "ETS2_CESTNEPROHLASENI": ETS2AffidavitFormSection
}